import { render, staticRenderFns } from "./tenderContract.vue?vue&type=template&id=40d8f97f&"
import script from "./tenderContract.vue?vue&type=script&lang=js&"
export * from "./tenderContract.vue?vue&type=script&lang=js&"
import style0 from "./tenderContract.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports